import Cards, { CardImage, MoreButton } from './Cards'
import React, { useEffect, useState } from 'react'
import { SendRequest, constants } from 'cng-web-lib'

import { ArticleCategory as Category } from 'src/constants'
import { EssenceApiUrls as Url } from 'src/apiUrls'
import pathMap from 'src/paths/pathMap'

const { AxiosMethod } = constants

function EventsSection() {
  const EVENTS_PATH = `${pathMap.HOME}/${Category.EVENT}`
  const [data, setData] = useState([])

  useEffect(() => {
    const getRequest = sendGetRequest()

    return () => {
      getRequest.abort()
    }
  }, [])

  function sendGetRequest() {
    const sendRequest = new SendRequest()
    sendRequest.execute(AxiosMethod.GET, Url.NEWEST_3_EVENT, {}, (body) => {
      setData(convertToLocalData(body.data.Data))
    })
    return sendRequest
  }

  function convertToLocalData(remoteData) {
    const data = remoteData.map((remoteDatum) => {
      const detailLink = `${EVENTS_PATH}/${remoteDatum.Id}`
      return {
        id: remoteDatum.Id,
        title: remoteDatum.Title,
        image: Url.CONTENT + remoteDatum.HeaderGraphicFilename,
        summary: remoteDatum.Summary,
        datetime: remoteDatum.PublishStartDate,
        detailLink
      }
    })
    return data
  }

  return (
    <Cards
      header='Upcoming Events'
      data={data}
      renderCardMedia={(event) => {
        return <CardImage src={event.image} />
      }}
      renderButtonSection={() => {
        return <MoreButton listUrl={EVENTS_PATH}>More Events</MoreButton>
      }}
    />
  )
}

export default EventsSection
